import React, { useEffect, useRef, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import {
  Badge,
  Button,
  Form,
  InputGroup,
  Modal,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import DatePicker from "react-datepicker";
import { Link, useLocation, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Icon, Stepper } from "@lomarengas/design-system";

import {
  changeStateSeasonRate,
  deleteSeasonRateAsync,
  getPriceHistoryAsync,
  getSeasonRatesAsync,
  RatePriceItem,
  saveSeasonRateAsync,
  SeasonRateDetails,
  selectPriceHistoryItems,
  selectPriceHistoryItemsLoadingStatus,
  selectSeasonRateItems,
  selectSeasonRateItemsLoadingStatus,
  updateSeasonRateAsync,
} from "./SeasonRatesSlice";
import {
  convertJSDateToDotNetDateTimeDayEnd,
  convertJSDateToDotNetDateTimeDayStart,
  convertJSDateToShortDateString,
  formattedAmountWithEuroCurrency,
  roundToCents,
  WEEKDAYS_SHORT,
} from "../../common/misc";
import InputErrorsDisplay from "../../features/errors/InputErrorsDisplay";
import {
  clearInputErrors,
  selectInputErrors,
} from "../../features/errors/errorsSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { addStatusToast } from "../../components/StatusToast";
import { LOADING_STATUS } from "../../common/constants";
import { selectAccommodationsLoadingStatus } from "../AccommodationsPage/accommodationsSlice";
import {
  getAccommodationDetailsBasicAsync,
  selectAccommodationDetailsBasic,
} from "../AccommodationsPage/accommodationSlice";

import LocalizedDatePicker from "../../components/DatePicker/LocalizedDatePicker";

import Draggable from "react-draggable";
import { ModalDialog, ModalDialogProps } from "react-bootstrap";
import { forEach } from "react-bootstrap/ElementChildren";

const DraggableDialog: React.FC<ModalDialogProps> = (props) => {
  const dialogRef = useRef<HTMLDivElement | null>(null);
  const [defaultPosition, setDefaultPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!dialogRef.current) return;

    const updatePosition = () => {
      const rect = dialogRef.current!.getBoundingClientRect();
      setDefaultPosition({
        x: window.innerWidth / 2 - rect.width / 2,
        y: window.innerHeight / 2 - rect.height / 2,
      });
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  return (
    <Draggable
      handle=".modal-header"
      cancel=".btn-close, .modal-header .btn, .modal-header [aria-label='Close'], [data-rr-ui-modal-close]"
      defaultPosition={defaultPosition}
    >
      {/* Forward ref + props directly */}
      <ModalDialog ref={dialogRef} {...props} />
    </Draggable>
  );
};

const PricingCabinPageType: Page = {
  ActiveTab: "pricing",
  DisplayName: "1234 Ankkalinna",
  DisplayParentName: "Hinnoittelu / Kohde",
  LinkUrl: "/pricing",
  Path: "/pricing",
  RouteName: "pricing",
};

const PRICING_OWNER_DEFINED = "OwnerDefined";
const PricingCabinPage = () => {
  const [percentByRate, setPercentByRate] = useState<Record<string, string>>(
    {},
  );
  // Usean hintakauden yhtäaikainen prosenttikorotus: valitut kaudet ja yhteinen prosentti.
  const [selectedRateIds, setSelectedRateIds] = useState<string[]>([]);
  const [bulkPercent, setBulkPercent] = useState<string>("");

  const isValidPercent = (v: string) => {
    if (v === "") return false;
    const n = Number(v);
    return !Number.isNaN(n) && n >= -99 && n <= 99;
  };

  const onPercentChange = (rate: SeasonRateDetails, val: string) => {
    setPercentByRate((prev) => ({ ...prev, [rate.id]: val }));
    if (val !== "" && !Number.isNaN(Number(val))) {
      handlePriceProcentualChange(rate, Number(val));
    }
  };

  const inputErrors = useAppSelector(selectInputErrors);
  const location = useLocation();
  const params = useParams();
  const [isOldPricingRowsVisible, setIsOldPricingRowsVisible] = useState(false);
  //const parsedQuery = queryString.parse(location.search.replace("?", ""));
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const accommodationName = urlParams.get("accommodation");
  const dispatch = useAppDispatch();
  const seasonRateItems = useAppSelector(selectSeasonRateItems);
  const seasonRateItemsLoadingStatus = useAppSelector(
    selectSeasonRateItemsLoadingStatus,
  );
  const priceHistoryItems = useAppSelector(selectPriceHistoryItems);
  const priceHistoryItemsLoadingStatus = useAppSelector(
    selectPriceHistoryItemsLoadingStatus,
  );
  // Hintakausi, jonka muutoshistoria näytetään modaalissa (null = suljettu).
  const [historyModalRate, setHistoryModalRate] =
    useState<SeasonRateDetails | null>(null);
  const accommodationsLoadingStatus = useAppSelector(
    selectAccommodationsLoadingStatus,
  );
  const accommodationDetailsBasic = useAppSelector(
    selectAccommodationDetailsBasic,
  );
  const [selectedAccommodationId, setSelectedAccommodationId] =
    useState<string>("");
  const [selectedAccommodationName, setSelectedAccommodationName] =
    useState<string>("");
  const today = new Date();
  const oneYearAgo = new Date(
    today.getFullYear() - 1,
    today.getMonth(),
    today.getDate(),
  );
  // Get accommodation info from url params, fetch default rate by accommodation id
  useEffect(() => {
    /*
            let accommodationName = '';
            if (parsedQuery.accommodation && parsedQuery.accommodation !== '') {
              accommodationName = decodeURI(parsedQuery.accommodation.toString());
            }
        
        setSelectedAccommodationName(accommodationName);
             */
    setSelectedAccommodationName(accommodationName);
    setSelectedAccommodationId(params.accommodationId);
  }, [params.accommodationId]); //, parsedQuery.accommodation]);
  // Use component's default rate to fetch season rate only if accommodation matches default rate
  useEffect(() => {
    if (selectedAccommodationId) {
      dispatch(
        getSeasonRatesAsync({
          accommodationId: selectedAccommodationId,
          startFetchingRatesFrom: oneYearAgo,
        }),
      );
      dispatch(getAccommodationDetailsBasicAsync(selectedAccommodationId));
    }
  }, [dispatch, selectedAccommodationId]);

  // Hintakauden muutoshistoria haetaan seasonRateId:llä "Näytä muutoshistoria"
  // -painikkeesta, ja modaali avataan vasta kun vastaus on saapunut. Näin modaali
  // ei näytä edellisen kauden arvoja haun ollessa kesken, ja epäonnistunut haku
  // näkyy virheilmoituksena eikä tyhjänä historiana. Haku tehdään aina uudelleen,
  // joten data on ajan tasalla myös tallennuksen jälkeen.
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Varoajan muokkaus -modaali (oma erillinen vahvistusmodaali per hintakausi)
  const [showPreparation, setShowPreparation] = useState(false);
  const [preparationSeasonRate, setPreparationSeasonRate] =
    useState<SeasonRateDetails>();
  const [preparationDaysValue, setPreparationDaysValue] = useState<number>(-1);
  const [preparationAccepted, setPreparationAccepted] = useState(false);
  const [maintainerInformed, setMaintainerInformed] = useState(false);

  const showPreparationModal = (seasonRate: SeasonRateDetails) => {
    setPreparationSeasonRate(seasonRate);
    setPreparationDaysValue(seasonRate.preparationDays ?? -1);
    setPreparationAccepted(false);
    setMaintainerInformed(false);
    setShowPreparation(true);
  };

  const handleClosePreparation = () => {
    setShowPreparation(false);
    setPreparationAccepted(false);
    setPreparationSeasonRate(undefined);
  };

  const handleSavePreparation = () => {
    if (!preparationSeasonRate) return;
    const modifiedSeasonRate = {
      ...preparationSeasonRate,
      preparationDays: preparationDaysValue,
    };
    saveSeasonRate(modifiedSeasonRate, false);
    handleClosePreparation();
  };

  const [showNew, setShowNew] = useState(false);
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [modalSeasonRateDetails, setModalSeasonRateDetails] =
    useState<SeasonRateDetails>();
  const [modalNewSeasonRateDetails, setModalNewSeasonRateDetails] =
    useState<SeasonRateDetails>();

  const [
    modalNewSeasonRateDetailsNameEmpty,
    setModalNewSeasonRateDetailsNameEmpty,
  ] = useState(false);
  const handleCloseNew = () => {
    if (modalNewSeasonRateDetailsNameEmpty) {
      setModalNewSeasonRateDetailsNameEmpty(false);
    }
    setShowNew(false);
  };

  // Laske prosenttimuutos esikatseluun yhdelle tai usealle kaudelle kerralla.
  // Baseline säilytetään tempPrice-kentissä, jotta prosenttia voi muuttaa
  // toistuvasti ilman että alkuperäinen hinta katoaa.
  const applyProcentualChangeToRates = (rateIds: string[], percent: number) => {
    const idSet = new Set(rateIds);
    const modifiedSeasonRates = seasonRateItems.map((item) => {
      if (idSet.has(item.id)) {
        const baselinePriceForAdditionalDay =
          item.tempPriceForProcentualDiscountForAdditionalDay ??
          item.discountedPriceForAdditionalDay ??
          item.priceForAdditionalDay;
        return {
          ...item,
          discountedPriceForAdditionalDay: roundToCents(
            baselinePriceForAdditionalDay * (1 + percent / 100),
          ),
          tempPriceForProcentualDiscountForAdditionalDay:
            item.tempPriceForProcentualDiscountForAdditionalDay ??
            baselinePriceForAdditionalDay,
          ratePrices: item.ratePrices.map((ratePrice) => {
            const baseline =
              ratePrice.tempPriceForProcentualDiscount ??
              ratePrice.discountedPrice ??
              ratePrice.dailyPrice;
            return {
              ...ratePrice,
              discountedPrice: roundToCents(baseline * (1 + percent / 100)),
              tempPriceForProcentualDiscount:
                ratePrice.tempPriceForProcentualDiscount ?? baseline,
            };
          }),
        };
      }
      return item;
    });

    dispatch(
      changeStateSeasonRate({ modifiedSeasonRate: modifiedSeasonRates }),
    );
  };

  const handlePriceProcentualChange = (seasonRate, percent: number) => {
    applyProcentualChangeToRates([seasonRate.id], percent);
  };

  // Vain tulevat (ei vanhentuneet) kaudet voidaan valita joukkokorotukseen.
  const selectableRateIds = seasonRateItems
    .filter((rate) => new Date(rate.endDate) >= new Date())
    .map((rate) => rate.id)
    .filter((id): id is string => id != null);
  const allSelectableSelected =
    selectableRateIds.length > 0 &&
    selectableRateIds.every((id) => selectedRateIds.includes(id));

  const toggleRateSelection = (rateId: string) => {
    setSelectedRateIds((prev) =>
      prev.includes(rateId)
        ? prev.filter((id) => id !== rateId)
        : [...prev, rateId],
    );
  };
  const toggleSelectAllRates = () => {
    setSelectedRateIds(allSelectableSelected ? [] : selectableRateIds);
  };
  // Esikatsele valittujen kausien uudet hinnat: aseta sama prosentti jokaisen
  // kauden omaan prosenttikenttään, jolloin näkymä ja hinnat päivittyvät
  // reaaliajassa täsmälleen kuten manuaalisesti riveille syötettäessä.
  const applyBulkPercentToSelectedRates = (val: string) => {
    // Tyhjä bulk-kenttä = nollaa korotukset: aseta jokaisen valitun kauden
    // prosenttikenttä 0:aan ja palauta hinnat perustasolle (0 % muutos).
    const effectiveVal = val === "" ? "0" : val;
    setPercentByRate((prev) => {
      const updated = { ...prev };
      selectedRateIds.forEach((id) => {
        updated[id] = effectiveVal;
      });
      return updated;
    });
    if (!Number.isNaN(Number(effectiveVal))) {
      applyProcentualChangeToRates(selectedRateIds, Number(effectiveVal));
    }
  };
  // Tallenna kaikki valitut kaudet kerralla; hae hinnat vasta lopuksi uudelleen,
  // jotta esikatseluhinnat eivät nollaannu kesken tallennuksen.
  const saveSelectedSeasonRates = async () => {
    const ratesToSave = seasonRateItems.filter((rate) =>
      selectedRateIds.includes(rate.id),
    );
    if (ratesToSave.length === 0) return;
    try {
      for (const seasonRate of ratesToSave) {
        const modifiedSeasonRate = {
          ...seasonRate,
          seasonRateType: PRICING_OWNER_DEFINED,
          priceForAdditionalDay: seasonRate.discountedPriceForAdditionalDay,
          ratePrices: seasonRate.ratePrices.map((item) => ({
            ...item,
            dailyPrice: item.discountedPrice,
          })),
        };
        await dispatch(updateSeasonRateAsync(modifiedSeasonRate)).then(
          unwrapResult,
        );
      }
      setSelectedRateIds([]);
      setBulkPercent("");
      setPercentByRate({});
      dispatch(
        addStatusToast({
          Message: `Tiedot tallennettu!`,
        }),
      );
      dispatch(clearInputErrors());
      dispatch(
        getSeasonRatesAsync({
          accommodationId: selectedAccommodationId,
          startFetchingRatesFrom: oneYearAgo,
        }),
      );
    } catch (error) {
      dispatch(
        addStatusToast({
          Title: "Virhe syötetyissä tiedoissa",
          Message: `Tarkista lomakkeen tiedot.`,
          IsFailed: true,
        }),
      );
    }
  };

  const handleShowNew = () => {
    let defaultStartDate = startDate;

    setModalNewSeasonRateDetails(
      new (class implements SeasonRateDetails {
        accommodationId: string = params.accommodationId;
        checkInTime: string = "16:00";
        checkOutTime: string = "12:00";
        commissionPercent: number = 20;
        dailyPurchasePrice: number = 0;
        endDate: string =
          convertJSDateToDotNetDateTimeDayStart(defaultStartDate);
        endDateString: string;
        id: string;
        isDeleted: boolean = false;
        priceForAdditionalDay: number = 0;
        discountedPriceForAdditionalDay: number = 0;
        tempPriceForProcentualDiscountForAdditionalDay: number = 0;
        ratePrices: RatePriceItem[] = [
          {
            duration: 1,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
          {
            duration: 2,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
          {
            duration: 3,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
          {
            duration: 4,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
          {
            duration: 5,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
          {
            duration: 6,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
          {
            duration: 7,
            dailyPrice: 0,
            dailyPurchasePrice: 0,
            discountedPrice: 0,
            isChanged: false,
            tempPriceForProcentualDiscount: null,
          },
        ];
        seasonName: string;
        seasonRateType: string = "3";
        startDate: string =
          convertJSDateToDotNetDateTimeDayStart(defaultStartDate);
        startDateString: string;
        preparationDays: number = -1;
        seasonRateColorHex: string = "#FFFFFF";
        seasonRateColorId: string = "";
        minBookingDuration: number = 1;
        restrictedCheckInWeekdays: [];
        restrictedCheckOutWeekdays: [];
        useParentSeasonCheckInAndCheckOutTimes: true;
      })(),
    );
    setShowNew(true);
  };

  let highlightWithRanges = [];
  const renderRatePrice = (seasonRate, ratePrice) => {
    return (
      <td
        key={
          seasonRate.accommodationId +
          "/" +
          seasonRate.id +
          "/" +
          ratePrice.duration
        }
      >
        <span className="d-sm-none">{ratePrice.duration} pv: </span>
        {ratePrice.discountedPrice ? (
          <>
            <span className="text-decoration-line-through d-block">
              {formattedAmountWithEuroCurrency(ratePrice.dailyPrice)}
            </span>
            {formattedAmountWithEuroCurrency(ratePrice.discountedPrice)}
          </>
        ) : (
          formattedAmountWithEuroCurrency(ratePrice.dailyPrice)
        )}
      </td>
    );
  };
  const renderRatesPrices = (seasonRate) => {
    return seasonRate.ratePrices.map((ratePrice) =>
      renderRatePrice(seasonRate, ratePrice),
    );
  };
  const showModal = (seasonRate) => {
    const editableSeasonRate = { ...seasonRate };

    if (editableSeasonRate.discountedPriceForAdditionalDay) {
      editableSeasonRate.priceForAdditionalDay =
        editableSeasonRate.discountedPriceForAdditionalDay;
    }

    setModalSeasonRateDetails(editableSeasonRate);
    setShow(true);
  };
  let lastSelectableDayOnCalendar: Date = new Date();
  const renderRate = (seasonRate) => {
    let rateCssClassName = "position-relative";
    if (seasonRate.seasonRateType == PRICING_OWNER_DEFINED) {
      rateCssClassName = "position-relative bg-warning-subtle";
    }
    // console.log(new Date(seasonRate.endDate));
    if (lastSelectableDayOnCalendar < new Date(seasonRate.endDate)) {
      lastSelectableDayOnCalendar = new Date(seasonRate.endDate);
    }
    let isOldPricingItem = false;
    if (new Date(seasonRate.endDate) < new Date()) {
      isOldPricingItem = true;
    }

    if (isOldPricingItem && !isOldPricingRowsVisible) {
      return <React.Fragment key={seasonRate.id ?? Math.random()} />;
    }
    return (
      <React.Fragment
        key={`${seasonRate.accommodationId}/${seasonRate.id ?? Math.random()}`}
      >
        <tr className={rateCssClassName}>
          <td className="align-middle text-center">
            {!isOldPricingItem && (
              <Form.Check
                type="checkbox"
                aria-label="Valitse hintakausi joukkokorotukseen"
                checked={selectedRateIds.includes(seasonRate.id)}
                onChange={() => toggleRateSelection(seasonRate.id)}
              />
            )}
          </td>
          <th>
            {seasonRate.seasonRateType == PRICING_OWNER_DEFINED && (
              <div className="mb-8">
                <Badge pill bg="primary">
                  Omistaja
                </Badge>
              </div>
            )}
            {!isOldPricingItem && (
              <Link to="" onClick={() => showModal(seasonRate)}>
                {seasonRate.startDateString} - {seasonRate.endDateString}
                <br />
                {seasonRate.seasonName}
              </Link>
            )}
            {isOldPricingItem && (
              <>
                {seasonRate.startDateString} - {seasonRate.endDateString}
                <br />
                {seasonRate.seasonName}
              </>
            )}
            <div>
              <Button
                variant="link"
                size="sm"
                className="p-0 fw-normal"
                onClick={async () => {
                  await dispatch(
                    getPriceHistoryAsync({
                      accommodationId: selectedAccommodationId,
                      seasonRateId: seasonRate.id,
                    }),
                  );
                  setHistoryModalRate(seasonRate);
                }}
              >
                Näytä muutoshistoria
              </Button>
            </div>
            {!isOldPricingItem && (
              <>
                <span className="d-block mt-8 fw-normal">
                  Hinnan alennus/korotus prosentti
                </span>
                <InputGroup className="mb-3 flex-nowrap" size="sm">
                  <Form.Control
                    type="number"
                    min={-99}
                    max={99}
                    step={1}
                    style={{ minWidth: 70 }}
                    value={percentByRate[seasonRate.id] ?? ""}
                    onKeyDown={(e) => {
                      const { key, currentTarget } = e;

                      // Block unwanted characters
                      if (["e", "E", "+", "."].includes(key)) {
                        e.preventDefault();
                      }

                      // Allow only one '-' and only at the start
                      if (key === "-") {
                        const val = currentTarget.value;
                        const cursorPos = currentTarget.selectionStart ?? 0;

                        // Allow if empty or cursor at start and no existing minus
                        const allowed =
                          (val === "" && cursorPos === 0) ||
                          (cursorPos === 0 && !val.includes("-"));

                        if (!allowed) {
                          e.preventDefault();
                        }
                      }
                    }}
                    onChange={(e) => {
                      const val = e.target.value;

                      // Allow empty so user can delete
                      if (val === "") {
                        onPercentChange(seasonRate, "");
                        return;
                      }

                      const num = Number(val);

                      // Enforce range
                      if (!Number.isNaN(num) && num >= -99 && num <= 99) {
                        onPercentChange(seasonRate, val);
                      }
                    }}
                  />

                  <InputGroup.Text className="bg-white">%</InputGroup.Text>
                  <Button
                    variant="primary"
                    onClick={() => saveSeasonRate(seasonRate, true)}
                    className="px-16"
                    disabled={
                      !isValidPercent(percentByRate[seasonRate.id] ?? "")
                    }
                  >
                    <Icon Name="floppy" />
                  </Button>
                </InputGroup>
                <Button
                  variant="outline-secondary"
                  size="sm"
                  onClick={() => showPreparationModal(seasonRate)}
                >
                  Muokkaa varoaikaa
                </Button>
              </>
            )}
          </th>
          {renderRatesPrices(seasonRate)}
          <td>
            <span className="d-sm-none">Lisä pv: </span>
            {seasonRate.discountedPriceForAdditionalDay ? (
              <>
                <span className="text-decoration-line-through d-block">
                  {formattedAmountWithEuroCurrency(
                    seasonRate.priceForAdditionalDay,
                  )}
                </span>
                {formattedAmountWithEuroCurrency(
                  seasonRate.discountedPriceForAdditionalDay,
                )}
              </>
            ) : (
              formattedAmountWithEuroCurrency(seasonRate.priceForAdditionalDay)
            )}
          </td>
          <td>
            <span className="d-sm-none">Min kesto: </span>
            {seasonRate.minBookingDuration}
            {seasonRate.releaseInterval && (
              <>
                <br />
                <span>Vapautus vrk: </span>
                {seasonRate.releaseInterval}
              </>
            )}
          </td>
          <td>
            <span className="d-sm-none">Varoaika: </span>
            {seasonRate.preparationDays !== null &&
              `${seasonRate.preparationDays} vrk`}
          </td>
          <td>
            <div className="d-flex gap-16">
              {seasonRate.restrictedCheckInWeekdays.length > 0 && (
                <div>
                  <span className="d-sm-none">Sääntö: </span>
                  <div className="fw-medium">Sisäänk.</div>
                  {WEEKDAYS_SHORT.filter(
                    (weekday) =>
                      !seasonRate.restrictedCheckInWeekdays.includes(
                        weekday.weekdayInt,
                      ),
                  ).map((weekday, index, array) => (
                    <span key={seasonRate.Id + "/" + weekday.weekdayInt}>
                      {weekday.weekdayString}
                      {index < array.length - 1 && ", "}
                    </span>
                  ))}
                </div>
              )}
              {seasonRate.restrictedCheckOutWeekdays.length > 0 && (
                <div>
                  <span className="d-sm-none">Sääntö: </span>
                  <div className="fw-medium">Ulosk.</div>
                  {WEEKDAYS_SHORT.filter(
                    (weekday) =>
                      !seasonRate.restrictedCheckOutWeekdays.includes(
                        weekday.weekdayInt,
                      ),
                  ).map((weekday, index, array) => (
                    <div key={weekday.weekdayInt}>
                      {weekday.weekdayString}
                      {index < array.length - 1 && ","}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </td>
          <td>
            {seasonRate.lastMinuteDaysUntilStart && (
              <div>
                <span>
                  <span className="d-sm-none">Äkkilähtö: </span>Vrk:{" "}
                </span>
                {seasonRate.lastMinuteDaysUntilStart}
              </div>
            )}
            {seasonRate.lastMinuteDiscount && (
              <div>
                <span>
                  <span className="d-sm-none">Äkkilähtö: </span>Hinnan muutos:{" "}
                </span>
                {seasonRate.lastMinuteDiscount}
              </div>
            )}
          </td>
        </tr>
      </React.Fragment>
    );
  };
  const renderRatesTable = () => {
    return seasonRateItems.map((seasonRate) => renderRate(seasonRate));
  };
  const handleExistingRateExtraPriceChange = (value: string) => {
    const modifiedSeasonRate = { ...modalSeasonRateDetails };
    modifiedSeasonRate.priceForAdditionalDay = +value;
    setModalSeasonRateDetails(modifiedSeasonRate);
  };

  const handleNewRateExtraPriceChange = (value: string) => {
    const modifiedNewSeasonRate = { ...modalNewSeasonRateDetails };
    modifiedNewSeasonRate.priceForAdditionalDay = +value;
    setModalNewSeasonRateDetails(modifiedNewSeasonRate);
  };

  const handleExistingRateDailyPriceChange = (
    duration: number,
    value: string,
  ) => {
    const modifiedSeasonRate = { ...modalSeasonRateDetails };
    let newPrice: number = +value;
    modifiedSeasonRate["ratePrices"] = modalSeasonRateDetails["ratePrices"].map(
      (item) => {
        if (item.duration.toString() === duration.toString()) {
          return { ...item, dailyPrice: newPrice, isChanged: true };
        } else {
          if (!item.isChanged && item.discountedPrice != null) {
            return {
              ...item,
              dailyPrice: item.discountedPrice,
              isChanged: true,
            };
          }
        }

        return item;
      },
    );
    setModalSeasonRateDetails(modifiedSeasonRate);
  };

  const handleExistingRateDiscountedDailyPriceChange = (
    duration: number,
    value: string,
  ) => {
    const modifiedSeasonRate = { ...modalSeasonRateDetails };
    let newPrice: number = +value;
    modifiedSeasonRate["ratePrices"] = modalSeasonRateDetails["ratePrices"].map(
      (item) => {
        if (item.duration.toString() === duration.toString()) {
          return { ...item, discountedPrice: newPrice };
        }
        return item;
      },
    );
    setModalSeasonRateDetails(modifiedSeasonRate);
  };

  const handleNewRateDailyPriceChange = (duration: number, value: string) => {
    const modifiedNewSeasonRate = { ...modalNewSeasonRateDetails };
    let newPrice: number = +value;
    modifiedNewSeasonRate["ratePrices"] = modalNewSeasonRateDetails[
      "ratePrices"
    ].map((item) => {
      if (item.duration.toString() === duration.toString()) {
        return { ...item, dailyPrice: newPrice };
      }
      return item;
    });
    setModalNewSeasonRateDetails(modifiedNewSeasonRate);
  };

  if (seasonRateItems != null) {
    highlightWithRanges = [];
    let startRates = [];
    let endRates = [];
    let ratesDuring = [];
    seasonRateItems.map((seasonRate) => {
      let startDate: Date = new Date(
        seasonRate.startDateString.split(".")[1] +
          "-" +
          seasonRate.startDateString.split(".")[0] +
          "-" +
          seasonRate.startDateString.split(".")[2],
      );
      let endDate: Date = new Date(
        seasonRate.endDateString.split(".")[1] +
          "-" +
          seasonRate.endDateString.split(".")[0] +
          "-" +
          seasonRate.endDateString.split(".")[2],
      );
      startRates.push(startDate);
      endRates.push(endDate);
      var loop = new Date(startDate);
      while (loop <= endDate) {
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
        ratesDuring.push(newDate);
      }
    });
    highlightWithRanges.push({
      "react-datepicker__day--reserved react-datepicker__legend react-datepicker__legend--a":
        startRates,
    });
    highlightWithRanges.push({
      "bg-warning": ratesDuring,
    });
    highlightWithRanges.push({
      "react-datepicker__day--reserved react-datepicker__legend react-datepicker__legend--v":
        endRates,
    });
  }
  const handleNewSeasonNameChange = (name: string) => {
    const modifiedNewSeasonRate = { ...modalNewSeasonRateDetails };
    modifiedNewSeasonRate.seasonName = name;
    setModalNewSeasonRateDetails(modifiedNewSeasonRate);
  };

  const ChangeNewSeasonStartOrEndDate = (startDate: boolean, date: Date) => {
    const modifiedNewSeasonRate = { ...modalNewSeasonRateDetails };
    if (startDate) {
      setStartDate(date);
      modifiedNewSeasonRate.startDate =
        convertJSDateToDotNetDateTimeDayStart(date);
      modifiedNewSeasonRate.startDateString =
        convertJSDateToShortDateString(date);
      // move enddate to startdate + 1 day
      const newEndDate = new Date(date);
      newEndDate.setDate(newEndDate.getDate() + 1);
      setEndDate(newEndDate);
      modifiedNewSeasonRate.endDate =
        convertJSDateToDotNetDateTimeDayStart(newEndDate);
      modifiedNewSeasonRate.endDateString =
        convertJSDateToShortDateString(newEndDate);
    } else {
      setEndDate(date);
      modifiedNewSeasonRate.endDate = convertJSDateToDotNetDateTimeDayEnd(date);
      modifiedNewSeasonRate.endDateString =
        convertJSDateToShortDateString(date);
    }
    setModalNewSeasonRateDetails(modifiedNewSeasonRate);
  };
  const selectPreparationDaysSelectChange = (e) => {
    const modifiedNewSeasonRate = { ...modalNewSeasonRateDetails };
    modifiedNewSeasonRate.preparationDays = e.target.value;
    setModalNewSeasonRateDetails(modifiedNewSeasonRate);
  };
  const selectExistingRatePreparationDaysSelectChange = (e) => {
    const modifiedExistingSeasonRate = { ...modalSeasonRateDetails };
    modifiedExistingSeasonRate.preparationDays = e.target.value;
    setModalSeasonRateDetails(modifiedExistingSeasonRate);
  };

  const ChangeExistingSeasonStartOrEndDate = (
    startDate: boolean,
    date: Date,
  ) => {
    const modifiedExistingSeasonRate = { ...modalSeasonRateDetails };
    if (startDate) {
      setStartDate(date);
      modifiedExistingSeasonRate.startDate =
        convertJSDateToDotNetDateTimeDayStart(date);
      modifiedExistingSeasonRate.startDateString =
        convertJSDateToShortDateString(date);
    } else {
      setEndDate(date);
      modifiedExistingSeasonRate.endDate =
        convertJSDateToDotNetDateTimeDayEnd(date);
      modifiedExistingSeasonRate.endDateString =
        convertJSDateToShortDateString(date);
    }
    setModalSeasonRateDetails(modifiedExistingSeasonRate);
  };
  const handleExistingRateDeletion = () => {
    if (modalSeasonRateDetails !== null) {
      dispatch(deleteSeasonRateAsync(modalSeasonRateDetails))
        .then(unwrapResult)
        .then((result) => {
          dispatch(
            addStatusToast({
              Message: `Tiedot tallennettu!`,
            }),
          );
          dispatch(clearInputErrors());
          dispatch(
            getSeasonRatesAsync({
              accommodationId: selectedAccommodationId,
              startFetchingRatesFrom: oneYearAgo,
            }),
          );
          setShow(false);
        })
        .catch((error) => {
          // Handle the rejected case
          dispatch(
            addStatusToast({
              Title: "Virhe syötetyissä tiedoissa",
              Message: `Tarkista lomakkeen tiedot.`,
              IsFailed: true,
            }),
          );
        });
    }
  };
  const saveSeasonRate = async (
    seasonRate: SeasonRateDetails | null,
    useDiscountedPriceAsDailyPrice: boolean,
  ) => {
    if (!seasonRate) return;

    const modifiedSeasonRate = {
      ...seasonRate,
      seasonRateType: PRICING_OWNER_DEFINED,
    };
    if (useDiscountedPriceAsDailyPrice) {
      // If used procentual discounting, then have to move prices from discountedprie -> DailyPrice
      // when saving, otherwise new, discountedprice, won't be saved
      modifiedSeasonRate.ratePrices = modifiedSeasonRate.ratePrices.map(
        (item) => ({
          ...item, // copy existing properties
          dailyPrice: item.discountedPrice, // overwrite dailyPrice
        }),
      );
      // overwrite priceForAdditionalDay with discountedPriceForAdditionalDay
      modifiedSeasonRate.priceForAdditionalDay =
        modifiedSeasonRate.discountedPriceForAdditionalDay;
    }
    if (useDiscountedPriceAsDailyPrice) {
      modifiedSeasonRate.ratePrices = modifiedSeasonRate.ratePrices.map(
        (item) => {
          item.dailyPrice = item.discountedPrice;
          return item;
        },
      );
    }
    try {
      await dispatch(updateSeasonRateAsync(modifiedSeasonRate)).then(
        unwrapResult,
      );
      if (useDiscountedPriceAsDailyPrice) {
        setPercentByRate((prev) => ({ ...prev, [seasonRate.id]: "" }));
      }
      dispatch(
        addStatusToast({
          Message: `Tiedot tallennettu!`,
        }),
      );
      dispatch(clearInputErrors());
      dispatch(
        getSeasonRatesAsync({
          accommodationId: selectedAccommodationId,
          startFetchingRatesFrom: oneYearAgo,
        }),
      );
      setShow(false);
    } catch (error) {
      dispatch(
        addStatusToast({
          Title: "Virhe syötetyissä tiedoissa",
          Message: `Tarkista lomakkeen tiedot.`,
          IsFailed: true,
        }),
      );
    }
  };

  const handleNewSeasonSave = () => {
    if (modalNewSeasonRateDetails !== null) {
      if (
        modalNewSeasonRateDetails.seasonName == null ||
        modalNewSeasonRateDetails.seasonName.trim() == ""
      ) {
        setModalNewSeasonRateDetailsNameEmpty(true);
        return;
      } else {
        setModalNewSeasonRateDetailsNameEmpty(false);
      }
      const newSeasonRateStart: Date = new Date(
        modalNewSeasonRateDetails.startDate,
      );
      const newSeasonRateEnd: Date = new Date(
        modalNewSeasonRateDetails.endDate,
      );
      let matchingSeasonRate = null;
      let earliestAfter = null;
      let latestBefore = null;
      seasonRateItems.forEach((seasonRate) => {
        const seasonRateStart: Date = new Date(seasonRate.startDate);

        if (seasonRateStart.getTime() === newSeasonRateStart.getTime()) {
          // Found a seasonRate starting at the same time
          matchingSeasonRate = seasonRate;
        } else if (
          seasonRateStart > newSeasonRateStart &&
          (!earliestAfter ||
            seasonRateStart < new Date(earliestAfter.startDate))
        ) {
          // Update earliest seasonRate starting after newSeasonRateStart
          earliestAfter = seasonRate;
        } else if (
          seasonRateStart < newSeasonRateStart &&
          (!latestBefore || seasonRateStart > new Date(latestBefore.startDate))
        ) {
          // Update latest seasonRate starting before newSeasonRateStart
          latestBefore = seasonRate;
        }
      });

      if (!matchingSeasonRate) {
        // If no exact match found, use the earliest after or latest before
        matchingSeasonRate = earliestAfter || latestBefore;
      }
      const modifiedNewSeasonRate = { ...modalNewSeasonRateDetails };
      modifiedNewSeasonRate.seasonRateType = PRICING_OWNER_DEFINED;
      modifiedNewSeasonRate.seasonRateIdToGetCommissionFrom =
        matchingSeasonRate.id;
      modifiedNewSeasonRate.useParentSeasonCheckInAndCheckOutTimes = true;
      dispatch(saveSeasonRateAsync(modifiedNewSeasonRate))
        .then(unwrapResult)
        .then((result) => {
          dispatch(
            addStatusToast({
              Message: `Tiedot tallennettu!`,
            }),
          );
          dispatch(clearInputErrors());
          dispatch(
            getSeasonRatesAsync({
              accommodationId: selectedAccommodationId,
              startFetchingRatesFrom: oneYearAgo,
            }),
          );
          setShowNew(false);
          /*
                              if (promise)
                                if (promise.payload === undefined) {
                                  //save failed
                                }
                              if (promise.payload !== undefined && promise.error) {
                                //save ok
                              }*/
        })
        .catch((error) => {
          // Handle the rejected case
          dispatch(
            addStatusToast({
              Title: "Virhe syötetyissä tiedoissa",
              Message: `Tarkista lomakkeen tiedot.`,
              IsFailed: true,
            }),
          );
        });
    }
  };
  const formatFieldValue = (raw: unknown) => {
    if (raw === null || raw === undefined) return "–";
    const num = typeof raw === "number" ? raw : Number(raw);
    if (!Number.isNaN(num)) {
      return `${num.toFixed(2)} €`;
    }
    return `${raw} €`;
  };

  // Poimii muuttuneet hinnat historian oldValues/newValues -objekteista:
  // kestokohtaiset hinnat (RatePrice = Kesto + Hinta) ja lisäpäivän hinta.
  // Kentät ovat backendissä valmiiksi suomennettuja (ks. HistoryLocalization).
  const extractPriceChanges = (
    oldValues?: Record<string, Record<string, unknown>> | null,
    newValues?: Record<string, Record<string, unknown>> | null,
  ) => {
    const oldObj = oldValues ?? {};
    const newObj = newValues ?? {};
    const entityKeys = Array.from(
      new Set([...Object.keys(oldObj), ...Object.keys(newObj)]),
    );

    const durationChanges: {
      duration: number;
      oldVal: unknown;
      newVal: unknown;
    }[] = [];
    let additionalDayChange: { oldVal: unknown; newVal: unknown } | null = null;

    entityKeys.forEach((entityKey) => {
      const oldProps = (oldObj[entityKey] ?? {}) as Record<string, unknown>;
      const newProps = (newObj[entityKey] ?? {}) as Record<string, unknown>;
      const duration = newProps["Kesto"] ?? oldProps["Kesto"];
      if (duration !== undefined && duration !== null) {
        // Hintakauden hinta (RatePrice) = kestokohtainen hinta.
        if (
          ("Hinta" in oldProps || "Hinta" in newProps) &&
          formatFieldValue(oldProps["Hinta"]) !==
            formatFieldValue(newProps["Hinta"])
        ) {
          durationChanges.push({
            duration: Number(duration),
            oldVal: oldProps["Hinta"],
            newVal: newProps["Hinta"],
          });
        }
      } else if (
        ("Lisäpäivän hinta" in oldProps || "Lisäpäivän hinta" in newProps) &&
        formatFieldValue(oldProps["Lisäpäivän hinta"]) !==
          formatFieldValue(newProps["Lisäpäivän hinta"])
      ) {
        additionalDayChange = {
          oldVal: oldProps["Lisäpäivän hinta"],
          newVal: newProps["Lisäpäivän hinta"],
        };
      }
    });

    durationChanges.sort((a, b) => a.duration - b.duration);
    return { durationChanges, additionalDayChange };
  };

  // Onko tallennuksessa hintamuutoksia. Käytetään suodattamaan pois tallennukset
  // jotka koskivat vain ei-hintakenttiä (ei näytetä tyhjää "–"-riviä).
  const historyItemHasPriceChanges = (item: {
    oldValues?: Record<string, Record<string, unknown>> | null;
    newValues?: Record<string, Record<string, unknown>> | null;
  }) => {
    const { durationChanges, additionalDayChange } = extractPriceChanges(
      item.oldValues,
      item.newValues,
    );
    return durationChanges.length > 0 || additionalDayChange !== null;
  };

  // Renderöi hintamuutokset taulukkona: sarakkeet = kestot (1pv, 2pv, …) kuten
  // hinnoittelusivulla ja niiden alla hintamuutos vanha → uusi. Lisäpäivän hinta
  // omana sarakkeenaan.
  const renderPriceHistoryChanges = (
    oldValues?: Record<string, Record<string, unknown>> | null,
    newValues?: Record<string, Record<string, unknown>> | null,
  ) => {
    const { durationChanges, additionalDayChange } = extractPriceChanges(
      oldValues,
      newValues,
    );
    const additional = additionalDayChange;

    return (
      <div className="table-responsive">
        <table className="table table-sm mb-0">
          <thead>
            <tr>
              {durationChanges.map((change) => (
                <th key={change.duration}>{change.duration}pv</th>
              ))}
              {additional !== null && <th>Lisäpäivä</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              {durationChanges.map((change) => (
                <td key={change.duration} className="text-nowrap">
                  <div>{formatFieldValue(change.oldVal)}</div>
                  <div>→ {formatFieldValue(change.newVal)}</div>
                </td>
              ))}
              {additional !== null && (
                <td className="text-nowrap">
                  <div>{formatFieldValue(additional.oldVal)}</div>
                  <div>→ {formatFieldValue(additional.newVal)}</div>
                </td>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  // console.log(lastSelectableDayOnCalendar);
  return (
    <div className={PricingCabinPageType.RouteName}>
      <Layout CurrentPage={PricingCabinPageType}>
        <PageHeader
          Title={selectedAccommodationName}
          AddButtonText="Uusi hintakausi"
          Print
          AddonClickFunction={handleShowNew}
          SubTitle={PricingCabinPageType.DisplayParentName}
        />

        {/*  <Tabs defaultActiveKey="taulukko" id="uncontrolled-tab-example">*/}
        {/*
          <Tab eventKey="kalenteri" title="Kalenteri">
            <div className="react-datepicker-inline react-datepicker-weeknumbers">
              <ReactDatePicker
                onChange={(date) => console.log(date)}
                inline
                showWeekNumbers
                highlightDates={highlightWithRanges}
              />
            </div>
          </Tab>
          */}
        {/* <Tab eventKey="taulukko" title="Taulukko">*/}
        <Button
          variant="link"
          size="sm"
          className="mb-16 p-0"
          onClick={() => setIsOldPricingRowsVisible(!isOldPricingRowsVisible)}
        >
          {isOldPricingRowsVisible
            ? "Piilota vanhentuneet hinnat"
            : "Näytä vanhentuneet hinnat"}
        </Button>
        <div className="border rounded p-16 mb-16 bg-light">
          <div className="fw-medium mb-8">
            Prosenttikorotus usealle hintakaudelle
          </div>
          <div className="d-flex flex-wrap gap-8 align-items-center">
            <span className="text-nowrap">
              Valittu {selectedRateIds.length} kautta
            </span>
            <InputGroup
              className="flex-nowrap"
              size="sm"
              style={{ width: "auto" }}
            >
              <Form.Control
                type="number"
                min={-99}
                max={99}
                step={1}
                disabled={selectedRateIds.length === 0}
                style={{ minWidth: 70 }}
                value={bulkPercent}
                onKeyDown={(e) => {
                  const { key, currentTarget } = e;

                  // Block unwanted characters
                  if (["e", "E", "+", "."].includes(key)) {
                    e.preventDefault();
                  }

                  // Allow only one '-' and only at the start
                  if (key === "-") {
                    const val = currentTarget.value;
                    const cursorPos = currentTarget.selectionStart ?? 0;

                    const allowed =
                      (val === "" && cursorPos === 0) ||
                      (cursorPos === 0 && !val.includes("-"));

                    if (!allowed) {
                      e.preventDefault();
                    }
                  }
                }}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "") {
                    setBulkPercent("");
                    applyBulkPercentToSelectedRates("");
                    return;
                  }
                  const num = Number(val);
                  if (!Number.isNaN(num) && num >= -99 && num <= 99) {
                    setBulkPercent(val);
                    applyBulkPercentToSelectedRates(val);
                  }
                }}
              />
              <InputGroup.Text className="bg-white">%</InputGroup.Text>
            </InputGroup>
            <Button
              variant="primary"
              size="sm"
              onClick={saveSelectedSeasonRates}
              disabled={selectedRateIds.length === 0}
            >
              Tallenna valitut ({selectedRateIds.length})
            </Button>
          </div>
        </div>
        <div>
          Kohteen oletusvaroaika:{" "}
          {accommodationDetailsBasic != null &&
            accommodationDetailsBasic.notOnSaleDays}{" "}
          vrk
        </div>
        <div className="table-responsive" style={{ maxHeight: "100vh" }}>
          <table className="table overflow-auto mb-0">
            <thead className="sticky-top z-3 bg-white shadow">
              <tr>
                <th scope="col">
                  <Form.Check
                    type="checkbox"
                    aria-label="Valitse kaikki hintakaudet"
                    checked={allSelectableSelected}
                    onChange={toggleSelectAllRates}
                    disabled={selectableRateIds.length === 0}
                  />
                </th>
                <th scope="col" className="col-2">
                  Hintakausi
                </th>
                <th scope="col">1 pv</th>
                <th scope="col">2 pv</th>
                <th scope="col">3 pv</th>
                <th scope="col">4 pv</th>
                <th scope="col">5 pv</th>
                <th scope="col">6 pv</th>
                <th scope="col">7 pv</th>
                <th scope="col">Lisä pv</th>
                <th scope="col">Min kesto</th>
                <th scope="col">Varoaika</th>
                <th scope="col">Säännöt</th>
                <th scope="col">Äkkilähtö-%</th>
              </tr>
            </thead>
            <tbody>{renderRatesTable()}</tbody>
          </table>
        </div>
        {/*  </Tab>*/}
        {/*</Tabs>*/}
        {seasonRateItemsLoadingStatus != LOADING_STATUS.IDLE && (
          <>
            <div className="d-flex gap-16 align-items-center mt-16">
              <Spinner animation="border" />
              <span>Ladataan hintoja...</span>
            </div>
          </>
        )}
        {modalNewSeasonRateDetails != null && (
          <Modal
            show={showNew}
            scrollable
            onHide={handleCloseNew}
            dialogAs={DraggableDialog}
            backdrop="static" // ⬅ disables close on backdrop click
            size="lg"
          >
            <Modal.Header closeButton className="cursor-grab">
              <Modal.Title>Uusi hintakausi</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className="d-flex flex-column gap-8">
                  <Form.Group>
                    <Form.Label>Hintakauden nimi</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={"Uuden hintakauden nimi"}
                      onChange={(e) =>
                        handleNewSeasonNameChange(e.target.value)
                      }
                      style={{
                        borderColor: modalNewSeasonRateDetailsNameEmpty
                          ? "red"
                          : "",
                        backgroundColor: modalNewSeasonRateDetailsNameEmpty
                          ? "#f8d7da"
                          : "",
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>Varoaika</Form.Label>
                    <Form.Select
                      aria-label="Varoaika"
                      id="selecPreparationDays"
                      onChange={(e) => selectPreparationDaysSelectChange(e)}
                    >
                      <option value="-1">
                        Kohteen varoaika{" "}
                        {accommodationDetailsBasic != null &&
                          accommodationDetailsBasic.notOnSaleDays + " vrk"}
                      </option>
                      <option value="0">0 vrk (kuluva päivä)</option>
                      <option value="1">1 vrk</option>
                      <option value="2">2 vrk</option>
                      <option value="3">3 vrk</option>
                      <option value="4">4 vrk</option>
                      <option value="5">5 vrk</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group>
                    {/*<Form.Label>Varoaika 1-5 vrk</Form.Label>*/}

                    <div className="d-flex  gap-8 align-items-center">
                      <div className="w-100 position-relative">
                        <LocalizedDatePicker
                          selected={startDate}
                          onChange={(date) =>
                            ChangeNewSeasonStartOrEndDate(true, date)
                          }
                          selectsStart
                          className="form-control"
                          dateFormat={"dd.MM.yyyy"}
                          minDate={new Date()}
                          maxDate={lastSelectableDayOnCalendar}
                          showWeekNumbers
                        />
                        <Button
                          variant="link"
                          className="px-8 px-sm-16 position-absolute end-0 top-0 pe-none"
                          id="button-addon2"
                        >
                          <span className="bi bi-calendar2-event"></span>
                        </Button>
                      </div>
                      <span className="bi bi-arrow-right"></span>
                      <div className="w-100 position-relative">
                        <LocalizedDatePicker
                          selected={endDate}
                          onChange={(date) =>
                            ChangeNewSeasonStartOrEndDate(false, date)
                          }
                          selectsEnd
                          minDate={
                            new Date(modalNewSeasonRateDetails.startDate)
                          }
                          maxDate={lastSelectableDayOnCalendar}
                          className="form-control"
                          dateFormat={"dd.MM.yyyy"}
                          showWeekNumbers
                        />
                        <Button
                          variant="link"
                          className="px-8 px-sm-16 position-absolute end-0 top-0 pe-none"
                          id="button-addon2"
                        >
                          <span className="bi bi-calendar2-event"></span>
                        </Button>
                      </div>
                    </div>
                  </Form.Group>
                  <div className="row row-cols-sm-2 g-16 pt-8">
                    {modalNewSeasonRateDetails.ratePrices.map((ratePrice) => (
                      <Form.Group
                        key={
                          modalNewSeasonRateDetails.id +
                          "newSeason/" +
                          ratePrice.duration
                        }
                      >
                        <Form.Label>
                          Hinta {ratePrice.duration} vrk/€
                        </Form.Label>
                        <Form.Control
                          type="number"
                          defaultValue={ratePrice.dailyPrice}
                          onChange={(e) =>
                            handleNewRateDailyPriceChange(
                              ratePrice.duration,
                              e.target.value,
                            )
                          }
                        />
                      </Form.Group>
                    ))}
                    <Form.Group>
                      <Form.Label>Lisävuorokaudet vrk/€</Form.Label>
                      <Form.Control
                        type="number"
                        defaultValue={
                          modalNewSeasonRateDetails.priceForAdditionalDay
                        }
                        onChange={(e) =>
                          handleNewRateExtraPriceChange(e.target.value)
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              {modalNewSeasonRateDetailsNameEmpty && (
                <p
                  style={{
                    color: "red",
                  }}
                >
                  Kauden nimi tyhjä!
                </p>
              )}
              <Button variant="link" onClick={handleCloseNew}>
                Peruuta
              </Button>
              <Button variant="primary" onClick={handleNewSeasonSave}>
                Tallenna
              </Button>
              <InputErrorsDisplay inputErrors={inputErrors} />
            </Modal.Footer>
          </Modal>
        )}
        {modalSeasonRateDetails != null && (
          <Modal
            show={show}
            onHide={handleClose}
            dialogAs={DraggableDialog}
            backdrop="static" // ⬅ disables close on backdrop click
            size="lg"
          >
            <Modal.Header closeButton className="cursor-grab">
              <Modal.Title>
                Muokkaa kautta {modalSeasonRateDetails.seasonName} <br />
                {modalSeasonRateDetails.startDateString +
                  " - " +
                  modalSeasonRateDetails.endDateString}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <div className="d-flex flex-column gap-8">
                  {modalSeasonRateDetails.seasonRateType ==
                    PRICING_OWNER_DEFINED && (
                    <Form.Group>
                      <Form.Label>Varoaika</Form.Label>
                      <Form.Select
                        aria-label="Varoaika"
                        id="selecPreparationDays"
                        value={modalSeasonRateDetails.preparationDays}
                        onChange={(e) =>
                          selectExistingRatePreparationDaysSelectChange(e)
                        }
                      >
                        <option value="-1">
                          Kohteen varoaika{" "}
                          {accommodationDetailsBasic != null &&
                            accommodationDetailsBasic.notOnSaleDays + " vrk"}
                        </option>
                        <option value="0">0 vrk (kuluva päivä)</option>
                        <option value="1">1 vrk</option>
                        <option value="2">2 vrk</option>
                        <option value="3">3 vrk</option>
                        <option value="4">4 vrk</option>
                        <option value="5">5 vrk</option>
                      </Form.Select>
                    </Form.Group>
                  )}
                  <Form.Group>
                    {/*<Form.Label>Varoaika 1-5 vrk</Form.Label>*/}
                    {modalSeasonRateDetails.seasonRateType ==
                      PRICING_OWNER_DEFINED && (
                      <div className="d-flex  gap-8 align-items-center">
                        <div className="w-100 position-relative">
                          <LocalizedDatePicker
                            onChange={(date) =>
                              ChangeExistingSeasonStartOrEndDate(true, date)
                            }
                            dateFormat={"dd.MM.yyyy"}
                            selected={
                              new Date(modalSeasonRateDetails.startDate)
                            }
                            minDate={new Date()}
                            maxDate={lastSelectableDayOnCalendar}
                            selectsStart
                            className="form-control"
                            showWeekNumbers
                          />
                          <Button
                            variant="link"
                            className="px-8 px-sm-16 position-absolute end-0 top-0 pe-none"
                            id="button-addon2"
                          >
                            <span className="bi bi-calendar2-event"></span>
                          </Button>
                        </div>
                        <span className="bi bi-arrow-right"></span>
                        <div className="w-100 position-relative">
                          <LocalizedDatePicker
                            dateFormat={"dd.MM.yyyy"}
                            onChange={(date) =>
                              ChangeExistingSeasonStartOrEndDate(false, date)
                            }
                            selected={new Date(modalSeasonRateDetails.endDate)}
                            minDate={new Date(modalSeasonRateDetails.startDate)}
                            maxDate={lastSelectableDayOnCalendar}
                            selectsEnd
                            className="form-control"
                            showWeekNumbers
                          />
                          <Button
                            variant="link"
                            className="px-8 px-sm-16 position-absolute end-0 top-0 pe-none"
                            id="button-addon2"
                          >
                            <span className="bi bi-calendar2-event"></span>
                          </Button>
                        </div>
                      </div>
                    )}
                  </Form.Group>
                  {/*<Form.Group>
                  <Form.Label>Valitse hintakausi/hintakaudet</Form.Label>
                  <MultiSelect
                    options={options}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                  />
                </Form.Group>*/}
                  {/* <Form.Group>
                  <Form.Label>Varoaika 1-5 vrk</Form.Label>
                  <Form.Select>
                    <option value="1">1 vrk</option>
                    <option value="2">2 vrk</option>
                    <option value="3">3 vrk</option>
                    <option value="4">4 vrk</option>
                    <option value="5">5 vrk</option>
                  </Form.Select>
                </Form.Group>*/}
                  <div className="row row-cols-sm-2 g-16">
                    {modalSeasonRateDetails.ratePrices.map((ratePrice) => (
                      <Form.Group
                        key={`${modalSeasonRateDetails.id ?? "modifiedRate"}/${ratePrice.duration}`}
                      >
                        {ratePrice.discountedPrice != null && (
                          <>
                            <Form.Label>
                              Kesto: {ratePrice.duration} Hinta:{" "}
                              {ratePrice.discountedPrice} vrk/€
                            </Form.Label>
                            <Form.Control
                              type="number"
                              defaultValue={ratePrice.discountedPrice}
                              onChange={(e) =>
                                handleExistingRateDailyPriceChange(
                                  ratePrice.duration,
                                  e.target.value,
                                )
                              }
                            />
                          </>
                        )}
                        {ratePrice.discountedPrice == null && (
                          <>
                            <Form.Label>
                              Kesto: {ratePrice.duration} Hinta{" "}
                              {ratePrice.dailyPrice} vrk/€
                            </Form.Label>
                            <Form.Control
                              type="number"
                              defaultValue={ratePrice.dailyPrice}
                              onChange={(e) =>
                                handleExistingRateDailyPriceChange(
                                  ratePrice.duration,
                                  e.target.value,
                                )
                              }
                            />
                          </>
                        )}
                      </Form.Group>
                    ))}
                    <Form.Group>
                      <Form.Label>
                        Lisävuorokaudet{" "}
                        {modalSeasonRateDetails.discountedPriceForAdditionalDay !=
                        undefined
                          ? modalSeasonRateDetails.discountedPriceForAdditionalDay
                          : modalSeasonRateDetails.priceForAdditionalDay}{" "}
                        vrk/€
                      </Form.Label>
                      <Form.Control
                        type="number"
                        defaultValue={
                          modalSeasonRateDetails.discountedPriceForAdditionalDay !=
                          undefined
                            ? modalSeasonRateDetails.discountedPriceForAdditionalDay
                            : modalSeasonRateDetails.priceForAdditionalDay
                        }
                        onChange={(e) =>
                          handleExistingRateExtraPriceChange(e.target.value)
                        }
                      />
                    </Form.Group>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              {modalSeasonRateDetails.seasonRateType ==
                PRICING_OWNER_DEFINED && (
                <Button
                  variant="btn btn-warning"
                  onClick={() =>
                    confirm("Oletko varma?") ? handleExistingRateDeletion() : ""
                  }
                >
                  POISTA KAUSI
                </Button>
              )}
              <Button variant="link" onClick={handleClose}>
                Peruuta
              </Button>
              <Button
                variant="primary"
                onClick={() => saveSeasonRate(modalSeasonRateDetails, false)}
              >
                Tallenna
              </Button>
              <InputErrorsDisplay inputErrors={inputErrors} />
            </Modal.Footer>
          </Modal>
        )}
        <Modal
          show={historyModalRate !== null}
          onHide={() => setHistoryModalRate(null)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Muutoshistoria
              {historyModalRate &&
                ` – ${historyModalRate.startDateString} - ${historyModalRate.endDateString} ${historyModalRate.seasonName}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {priceHistoryItemsLoadingStatus === LOADING_STATUS.LOADING && (
              <div className="d-flex gap-16 align-items-center">
                <Spinner animation="border" />
                <span>Ladataan muutoshistoriaa...</span>
              </div>
            )}
            {(() => {
              if (priceHistoryItemsLoadingStatus === LOADING_STATUS.FAILED) {
                return (
                  <p className="mb-0">
                    Muutoshistorian lataaminen ei onnistunut.
                  </p>
                );
              }
              const rateHistoryItems = priceHistoryItems.filter(
                (item) =>
                  item.eventType === "SeasonRateUpdatedEvent" &&
                  historyModalRate != null &&
                  item.targetId?.toLowerCase() ===
                    historyModalRate.id?.toLowerCase() &&
                  historyItemHasPriceChanges(item),
              );
              if (
                priceHistoryItemsLoadingStatus !== LOADING_STATUS.LOADING &&
                rateHistoryItems.length === 0
              ) {
                return <p className="mb-0">Ei hintamuutoksia.</p>;
              }
              return rateHistoryItems.map((item) => {
                const author = [item.authorFirstName, item.authorLastName]
                  .filter(Boolean)
                  .join(" ");
                return (
                  <div key={item.id} className="pb-12 mb-16">
                    <div className="text-muted mb-8">
                      {new Date(item.timestamp).toLocaleString("fi-FI")}
                      {author && ` – ${author}`}
                    </div>
                    {renderPriceHistoryChanges(item.oldValues, item.newValues)}
                  </div>
                );
              });
            })()}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="link" onClick={() => setHistoryModalRate(null)}>
              Sulje
            </Button>
          </Modal.Footer>
        </Modal>
        {preparationSeasonRate != null && (
          <Modal
            show={showPreparation}
            onHide={handleClosePreparation}
            dialogAs={DraggableDialog}
            backdrop="static" // ⬅ disables close on backdrop click
            size="lg"
          >
            <Modal.Header closeButton className="cursor-grab">
              <Modal.Title>
                Muokkaa varoaikaa
                <br />
                {preparationSeasonRate.seasonName} (
                {preparationSeasonRate.startDateString} -{" "}
                {preparationSeasonRate.endDateString})
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-16">
                  <Form.Label>Varoaika</Form.Label>
                  <Form.Select
                    aria-label="Varoaika"
                    value={preparationDaysValue}
                    onChange={(e) =>
                      setPreparationDaysValue(Number(e.target.value))
                    }
                  >
                    <option value="-1">
                      Kohteen varoaika{" "}
                      {accommodationDetailsBasic != null &&
                        accommodationDetailsBasic.notOnSaleDays + " vrk"}
                    </option>
                    <option value="0">0 vrk (kuluva päivä)</option>
                    <option value="1">1 vrk</option>
                    <option value="2">2 vrk</option>
                    <option value="3">3 vrk</option>
                    <option value="4">4 vrk</option>
                    <option value="5">5 vrk</option>
                  </Form.Select>
                </Form.Group>
                <div className="alert alert-info" role="alert">
                  <p className="mb-8 fw-medium">
                    Mitä varoajan muutos tarkoittaa?
                  </p>
                  <p className="mb-8">
                    Varoaika määrittää kuinka monta vuorokautta ennen
                    varausjakson alkua kohde ei ole varattavissa.
                    Varoaikajärjestelmä toimii näin:
                    <p></p>
                    <p>
                      Varoaika 0 = asiakas voi tehdä varauksen samalle päivälle
                      (asiakas voi tehdä varauksen vaikka illalla ja saapua
                      heti)
                    </p>
                    <p>Varoaika 1 = varaus voi alkaa seuraavana päivänä</p>
                    <p>
                      Varoaika 2 = varaus voi alkaa ylihuomenna, ja niin
                      edelleen
                    </p>
                    Huomaathan, että varoaika 0 mahdollistaa samalle päivälle
                    alkavat varaukset ilman kellonaikarajaa.
                  </p>
                  <p className="mb-0">
                    Tässä tehtävä muutos koskee vain tätä hintakautta ja korvaa
                    kohteen oletusvaroajan.
                  </p>
                </div>
                <Form.Check
                  type="checkbox"
                  id="preparationAccept"
                  checked={preparationAccepted}
                  onChange={(e) => setPreparationAccepted(e.target.checked)}
                  label="Ymmärrän, että varoajan muutos vaikuttaa siihen, milloin tämän hintakauden päivät ovat asiakkaiden varattavissa, ja hyväksyn muutoksen."
                />
                <Form.Check
                  type="checkbox"
                  id="maintainerInformed"
                  checked={maintainerInformed}
                  onChange={(e) => setMaintainerInformed(e.target.checked)}
                  label="Kohteen huoltaja on tietoinen varoajan muutoksesta ja hyväksyy sen."
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="link" onClick={handleClosePreparation}>
                Peruuta
              </Button>
              <Button
                variant="primary"
                onClick={handleSavePreparation}
                disabled={!preparationAccepted || !maintainerInformed}
              >
                Tallenna
              </Button>
              <InputErrorsDisplay inputErrors={inputErrors} />
            </Modal.Footer>
          </Modal>
        )}
      </Layout>
    </div>
  );
};

export default PricingCabinPage;
